import { faTruckPlow } from "@fortawesome/pro-light-svg-icons";
import $ from "jquery";

if (document.querySelectorAll(".blog-slider")) {
    const blogSliders = document.querySelectorAll(".blog-slider-std");
    
    blogSliders.forEach(slider => {

  
        const containerArrows = slider.parentNode.parentNode.querySelector(".slider-controls__arrows");
        const containerDots = slider.parentNode.parentNode.querySelector(".slider-controls__dots");

        console.log(containerArrows);
            
        $(slider).slick({
            slidesToShow: 4,
            appendArrows: containerArrows,
            appendDots: containerDots,
            dots: true,
            slidesToScroll: 4,
            prevArrow: "<button type='button' class='slick-prev d-none d-md-block'><i class='fal fa-chevron-left'></i></button>",
            nextArrow: "<button type='button' class='slick-next'><i class='fal fa-chevron-right'></i></button>",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });

}

if (document.querySelector(".blog-slider-exito")) {

  const blogExito = document.querySelectorAll(".blog-slider-casos");
    
  blogExito.forEach(sliderE => {
  
    const containerArrowse = sliderE.parentNode.parentNode.querySelector(".slider-controls__arrows");
    const containerDotse = sliderE.parentNode.parentNode.querySelector(".slider-controls__dots");

    $(sliderE).slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: true,
      autoplaySpeed: 2000,
      appendArrows: containerArrowse,
      appendDots: containerDotse,
      dots: true,
      centerMode: true,
      centerPadding: '20%',
      prevArrow: "<button type='button' class='slick-prev'><i class='fal fa-chevron-left'></i></button>",
      nextArrow: "<button type='button' class='slick-next'><i class='fal fa-chevron-right'></i></button>",
      responsive: [
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
}